import React, { useEffect, useMemo, useRef, useState } from 'react';
import Main from '../Main';
import { Button, Col, Dropdown, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import { Box, Tabs, Tab } from '@mui/material';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import '../../assets/css/usermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbFilterBtn, SDownloadBtn } from '../Buttons/Buttons';
import UserManagementTable from './UserManagementTable';
import SbDropdownButton from '../Buttons/SbDropdownButton';
import AddUserModal from './AddUserModal';
import Download from '../MainSection/Download/Download';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ViewUserModal from './ViewUserModal';
import AddSlocModal from './AddSlocModal';
import UserValueFilterModal from './UserValueFilterModal';
import UserColumnFilterModal from './UserColumnFilterModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadCustomFieldsForUser, loadCustomviews, loadModuleFieldNames, loadSingleUserManagementData, loadUserCustomFieldData, loadUserManagementData } from '../../redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import moment from 'moment';
import { baseURL } from '../BaseUrl';
import * as HeaderAuthentication from '../HeaderAuthentication'
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';
import UserManagementBulkUploadModal from './UserManagementBulkUploadModal';

const UserManagement = () => {

    const { id: userRefId } = useParams();
    let dispatch = useDispatch();
    let location = useLocation();
    const { selectedDashboardID } = location.state || {};
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const { userData = [] } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);
    const { singleUserData } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);
    const { getUserCustomFields, getModuleFieldsNames, getUserCustomFieldData } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    // useEffect(() => {
    //     if (moduleId && storedModulePermissions.length) {
    //         // Find the module data using the moduleId
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
    //         setModuleData(module);
    //     }
    // }, [storedModulePermissions, moduleId]);

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Loop through storedModulePermissions and nested MainModules and SubModules to find the matching ModuleID
            let foundModule = null;

            outerLoop:
            for (const sidebarMenu of storedModulePermissions) {
                for (const mainModule of sidebarMenu.MainModules) {
                    if (mainModule.SubModules && mainModule.SubModules.length > 0) {
                        const subModule = mainModule.SubModules.find(sub => sub.ModuleID === moduleId);
                        if (subModule) {
                            foundModule = subModule;
                            break outerLoop;
                        }
                    }
                }
            }

            setModuleData(foundModule);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [openSlocModal, setOpenSlocModal] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [files, setFiles] = useState([]);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [progress, setProgress] = useState([]);
    const [tabValue, setTabValue] = useState(0);
    const [droppedFile, setDroppedFile] = useState(null);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [userID, setUserID] = useState("")
    const [selectedColumns, setSelectedColumns] = useState([
        "ID", "NAME", "Email.ID", "HOME ADDRESS", "WORK ADDRESS", "CONTACT", "JOINING DATE",
        "ROLE", "REPORTING TO", "APPROVALS", "STATUS", "SET SLOC", "ACTION"
    ]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchParams, setSearchParams] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const fileInputRef = useRef(null);
    const [customFields, setCustomFields] = useState([]);
    const [selected, setSelected] = useState([]);
    const [fieldValues, setFieldValues] = useState({});
    const [checkedData, setCheckedData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSingleUserManagementData(userRefId, setDataLoading));
        } else {
            userManagenemtData();
        }
    }, [userRefId]);

    const userManagenemtData = () => {
        dispatch(loadUserManagementData(setLoading, searchQuery, searchParams));
    }

    useEffect(() => {
        userManagenemtData();
    }, [searchQuery, searchParams]);

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2025
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 15-Jan-2025

            // Build the WHERE clause with formatted dates
            const whereClause = `CONVERT(DATE,U.Users_DOJ,101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,U.Users_DOJ,101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update the searchParams state with the final WHERE clause
            setSearchParams(whereClause);
        } else {
            // Clear date filter if no dates are selected
            setSearchParams('');
        }
    }, [fromDate, toDate]); // The dependencies include fromDate, toDate, and searchText    

    useEffect(() => {
        dispatch(loadCustomFieldsForUser());
    }, [])

    useEffect(() => {
        if (getUserCustomFields) {
            setCustomFields(getUserCustomFields);
        }
    }, [getUserCustomFields]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleOpenModal = (userId) => {
        setIsModalOpen(true);
        dispatch(loadModuleFieldNames(null, 3, null));
        if (userId) {
            dispatch(loadSingleUserManagementData(userId, setDataLoading));
            setUserID(userId);
            dispatch(loadUserCustomFieldData(setLoading, userId));
        } else {
            setUserID("");
        }
    };

    const handleCloseModal = () => {
        setUserID("");
        dispatch(loadSingleUserManagementData(null, setDataLoading));
        setIsModalOpen(false);
    };
    const handleOpenViewModal = (userId) => {
        setViewModal(true);
        if (userId) {
            dispatch(loadSingleUserManagementData(userId, setDataLoading));
            setUserID(userId);
        } else {
            setUserID("");
        }
    };

    const handleCloseViewModal = () => {
        setUserID("");
        dispatch(loadSingleUserManagementData(null, setDataLoading));
        setViewModal(false);
    };
    const handleOpenSloc = (userId) => {
        setOpenSlocModal(true);
        if (userId) {
            dispatch(loadSingleUserManagementData(userId, setDataLoading));
            setUserID(userId);
        } else {
            setUserID("");
        }
    };

    const handleCloseSlocModal = () => {
        setUserID("");
        dispatch(loadSingleUserManagementData(null, setDataLoading));
        setOpenSlocModal(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }
    const handleCloseViewDetails = () => {
        setShowCustomerViewDetails(false);
    }
    const [showAddUserModa, setAddUserModal] = useState(false)
    const openAddModal = () => {
        setAddUserModal(true);
    };

    const handleOpenBulkUploadModal = () => {
        // Reset the state before opening the modal
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
        setShowBulkUploadModal(true);
    };

    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        // Reset states when closing the modal if needed
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
    };

    // const handleFileChange = (event) => {
    //     const newFiles = Array.from(event.target.files);
    //     processFiles(newFiles);
    // };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setDroppedFile(file);
            setProgress(0);
            setUploadComplete(false);
            simulateUpload();
        }
    };

    // const handleDrop = (event) => {
    //     event.preventDefault();
    //     const newFiles = Array.from(event.dataTransfer.files);
    //     processFiles(newFiles);

    //     if (newFiles.length > 0) {
    //         setDroppedFile(newFiles[0]);
    //     }
    // };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setDroppedFile(file);
            setProgress(0);
            setUploadComplete(false);
            simulateUpload();
        }
    };

    const simulateUpload = (file) => {
        setProgress(0);
        setUploadComplete(false);
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setUploadComplete(true);
                    return 100;
                }
                return prev + 10;
            });
        }, 200);
    };

    const processFiles = (newFiles) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        setProgress((prevProgress) => [
            ...prevProgress,
            ...newFiles.map(() => 0)
        ]);
        simulateProgress(newFiles.length);
    };

    const simulateProgress = (newFileCount) => {
        const currentFileIndex = files.length;
        for (let i = 0; i < newFileCount; i++) {
            let progressValue = 0;
            const interval = setInterval(() => {
                if (progressValue >= 100) {
                    clearInterval(interval);
                    setUploadComplete(true); // Set completion status
                    return;
                }
                progressValue += 10;
                setProgress((prevProgress) => {
                    const newProgress = [...prevProgress];
                    newProgress[currentFileIndex + i] = progressValue;
                    return newProgress;
                });
            }, 500);
        }
    };

    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setProgress((prevProgress) => prevProgress.filter((_, i) => i !== index));
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Combine first, middle, and last name into a full name
    const getFullName = (user) => {
        return `${user.FirstName} ${user.MiddleName ? user.MiddleName + ' ' : ''}${user.LastName}`;
    };

    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedUserId = query.UserID;
        // setSearchQuery(query);
        setSearchQuery(selectedUserId);
        setSearchText(query);
        setSelected(selected);
    };

    // Trigger search when typing (debounced)
    // useEffect(() => {
    //     const delayDebounce = setTimeout(() => {
    //         setSearchQuery(searchText);
    //     }, 500);

    //     return () => clearTimeout(delayDebounce);
    // }, [searchText]);

    const signInType = signInDetails?.[0]?.SignInType;
    const signInId =
        signInType === "SuperAdmin"
            ? signInDetails?.[0]?.SuperAdminID
            : signInType === "ClientAdmin"
                ? signInDetails?.[0]?.CompanyID
                : signInType === "User"
                    ? signInDetails?.[0]?.UserID
                    : null;

    const navigate = useNavigate();
    const [customViewsLoading, setCustomViewsLoading] = useState(true);
    const handleAnalyticsClick = () => {
        // if (customViews[0]?.IsDefault === true) {
        //     dispatch(loadCustomviews(null, signInType, signInId, 3));
        // }
        setCustomViewsLoading(true);
        dispatch(loadCustomviews(null, signInType, signInId, 3, setCustomViewsLoading));
        navigate('/licenceDashboard', { state: { selectedDashboardID, customViewsLoading } })
    }

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        userManagenemtData();
        setSelected([]);
    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = userData?.map(item => ({
            "ID": item.UserID || "NA",
            "NAME": item.FirstName || "NA",
            "Email.ID": item.EmailID || "NA",
            "ADDRESS": item.HomeAddress || "NA",
            "CONTACT": item.Phone || "NA",
            "ROLE": item.RoleName || "NA",
            "REPORTING TO": item.ReportingTo || "NA",
            "STATUS": item.Status || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Users");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'user_management.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("User Management Data", 14, 20);

        const dataToExport = userData?.map(item => ([
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ])) || [];

        const columns = [
            { title: "ID", dataKey: "id" },
            { title: "NAME", dataKey: "name" },
            { title: "Email.ID", dataKey: "emailId" },
            { title: "ADDRESS", dataKey: "address" },
            { title: "CONTACT", dataKey: "contact" },
            { title: "ROLE", dataKey: "role" },
            { title: "REPORTING TO", dataKey: "reportingRo" },
            { title: "STATUS", dataKey: "status" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'center',
            },
        });

        // Save PDF
        doc.save('user_management.pdf');
    };

    const handleDownloadWord = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = userData.map(item => [
            String(item?.UserID || "NA"),  // Explicitly convert to string
            String(item?.FirstName || "NA"),  // Explicitly convert to string
            String(item?.EmailID || "NA"),  // Explicitly convert to string
            String(item?.HomeAddress || "NA"),  // Explicitly convert to string
            String(item?.Phone || "NA"),  // Explicitly convert to string
            String(item?.RoleName || "NA"),  // Explicitly convert to string
            String(item?.ReportingTo || "NA"),  // Explicitly convert to string
            String(item?.Status || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "User Management System",
            title: "User Management Report",
            description: "A detailed report of user management.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "user_management.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = userData.map(item => [
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>User Management Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>User Management Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!userData || userData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = userData.map(item => [
            item.UserID || "NA",
            item.FirstName || "NA",
            item.EmailID || "NA",
            item.HomeAddress || "NA",
            item.Phone || "NA",
            item.RoleName || "NA",
            item.ReportingTo || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "NAME", "Email.ID", "ADDRESS", "CONTACT", "ROLE",
            "REPORTING TO", "STATUS",
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'user_management_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    const handleEmailWithCsvDownload = async () => {
        const users = Array.isArray(userData) ? userData : [userData];

        if (!users || users.length === 0) {
            // toast.error("No user data to export.");
            console.log("No user data to export.");
            return;
        }

        const dataToExport = users.map(item => {
            const roles = (item.UserRoles && Array.isArray(item.UserRoles))
                ? item.UserRoles.map(role => role.RoleName).join("; ")
                : "NA";

            return {
                "ID": item.UserID || "NA",
                "NAME": item.FirstName || "NA",
                "Email.ID": item.EmailID || "NA",
                "ADDRESS": item.HomeAddress || "NA",
                "CONTACT": item.Phone || "NA",
                "ROLES": roles,
                "REPORTING TO": item.ReportingTo || "NA",
                "STATUS": item.Status || "NA",
            };
        });

        const headers = Object.keys(dataToExport[0]);
        const csvRows = [headers.join(",")];
        dataToExport.forEach(row => {
            const values = headers.map(header => `"${String(row[header]).replace(/"/g, '""')}"`);
            csvRows.push(values.join(","));
        });

        const csvContent = "\uFEFF" + csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const base64 = await blobToBase64(blob);

        const sessionData = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
        const signInType = sessionData[0]?.SignInType;
        let userID = null;

        if (signInType === "SuperAdmin") userID = sessionData[0]?.SuperAdminID;
        else if (signInType === "ClientAdmin") userID = sessionData[0]?.CompanyID;
        else if (signInType === "User") userID = sessionData[0]?.UserID;

        fetch(`${baseURL}/excomatixservices/api/Mail/PostAttachCSVDocument`, {
            method: "POST",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                UserID: userID,
                FileName: "user_data.csv",
                File: base64.split(',')[1],
            }),
        })
            .then(res => res.json())
            .then(resp => {
                if (resp.Success === 1 && resp.FilePath) {
                    // toast.success("CSV uploaded successfully.");
                    console.log("CSV uploaded successfully.");

                    const subject = encodeURIComponent("CSV File: User Data");
                    const body = encodeURIComponent(
                        `Hi,\n\nPlease find the link to download the CSV file below:\n\n${resp.FilePath}\n\nThanks!`
                    );

                    // No "to" address, user can enter manually
                    window.location.href = `mailto:?subject=${subject}&body=${body}`;
                } else {
                    // toast.error("Upload failed. " + (resp.Msg || ""));
                    console.log("Upload failed. " + (resp.Msg || ""));
                }
            })
            .catch(err => {
                console.error("Upload Error:", err);
                // toast.error("Error uploading CSV file.");
            });
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    const processedWorkqueueData = useMemo(() => {
        return userData.map(item => ({
            ...item,
            FirstName: item.FirstName || 'N/A',
            EmailID: item.EmailID || '',
            Phone: item.Phone || '',
            DepartmentName: item.DepartmentName || '',
            ReportingTo: item.ReportingTo || '',
        }));
    }, [userData]);

    return (
        <div className="customer-management-container" >
            <Main>
                <div className='components-download-container'>
                    <Download
                        SignInType={signInDetails[0]?.SignInType}
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                        onEmailCsvClick={handleEmailWithCsvDownload}
                        customViews={customViews}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                <span>User Management &nbsp;({userData?.[0]?.AciveUser || 0}/{userData?.[0]?.CompanyLicense || 0})</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={4} className='filters-col'>
                                    {/* <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div> */}
                                    <Typeahead
                                        id="search-typeahead"
                                        className='typeahead-search'
                                        onChange={handleSearchChange}
                                        // options={getViewAssignedWorkqueueData.map(workQueue => workQueue.WorkQueueRuleName)}  // Use WorkQueueRuleName or any other field
                                        options={processedWorkqueueData}
                                        // labelKey={(option) => option}  // Assuming we're using the name for display
                                        labelKey="FirstName"
                                        filterBy={['FirstName', 'EmailID', 'Phone', 'DepartmentName', 'ReportingTo']}
                                        placeholder="Search User"
                                        value={searchText}
                                        selected={selected}
                                        onInputChange={(input) => setSearchText(input)}  // Update searchText with typed value
                                        minLength={1}  // Minimum characters before suggestions appear
                                        autoFocus={false}  // Prevent auto focusing on input

                                        renderMenu={(results, menuProps) => {
                                            // ✅ Hide table if an item is selected
                                            if (selected.length > 0 || !results.length) {
                                                return null;
                                            }

                                            return (
                                                <div {...menuProps} className='typeahead-search-options-table'>
                                                    <table className="table table-sm  mb-0">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th style={{ 'minWidth': '100px' }}>Name</th>
                                                                <th style={{ 'minWidth': '120px' }}>Email</th>
                                                                <th style={{ 'minWidth': '120px' }}>Phone</th>
                                                                <th style={{ 'minWidth': '250px' }}>Department</th>
                                                                <th style={{ 'minWidth': '180px' }}>ReportingTo</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {results.map((option, index) => (
                                                                <tr key={option.UserID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                                    <td><Highlighter search={searchText}>{option.FirstName}</Highlighter></td>
                                                                    <td><Highlighter search={searchText}>{option.EmailID}</Highlighter></td>
                                                                    <td><Highlighter search={searchText}>{option.Phone}</Highlighter></td>
                                                                    <td><Highlighter search={searchText}>{option.DepartmentName}</Highlighter></td>
                                                                    <td><Highlighter search={searchText}>{option.ReportingTo}</Highlighter></td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        }}
                                    />
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='To'
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                {/* <div className='customermanagement-header-btns add-btn' onClick={handleOpenModal}>
                                <Button><img src={add} alt="" className='filter-img' />Add User</Button>
                            </div> */}
                                {/* <SbAddBtn btnName="Add User" onClickEffect={handleOpenModal} /> */}
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {moduleData?.CanCreate === true && <SbDropdownButton
                                    openAddModal={() => { handleOpenModal("") }}
                                    pageName="User"
                                    btnName="Add"
                                    addBulkModel={handleOpenBulkUploadModal}
                                />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <UserManagementTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                handleOpenViewModal={handleOpenViewModal}
                                handleOpenSloc={handleOpenSloc}
                                handleOpenValueFilterModal={handleOpenValueFilterModal}
                                userData={userData}
                                userID={userID}
                                loading={loading}
                                selectedColumns={selectedColumns}
                                moduleData={moduleData}
                                singleUserData={singleUserData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>

            {
                isModalOpen && <AddUserModal
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    userManagenemtData={userManagenemtData}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    getModuleFieldsNames={getModuleFieldsNames}
                    getUserCustomFieldData={getUserCustomFieldData}
                    fieldValues={fieldValues}
                    setFieldValues={setFieldValues}
                    checkedData={checkedData}
                    setCheckedData={setCheckedData}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <UserManagementBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    userManagenemtData={userManagenemtData}
                />
            }
            {
                viewModal && <ViewUserModal
                    viewModal={viewModal}
                    handleCloseViewModal={handleCloseViewModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    customFields={customFields}
                    setLoading={setLoading}
                    dataLoading={dataLoading}
                />
            }
            {
                openSlocModal && <AddSlocModal
                    openSlocModal={openSlocModal}
                    handleCloseSlocModal={handleCloseSlocModal}
                    singleUserData={singleUserData}
                    userID={userID}
                    userManagenemtData={userManagenemtData}
                    setUserID={setUserID}
                    dataLoading={dataLoading}
                />
            }
            {
                showColumnFilterModal && (
                    <UserColumnFilterModal
                        showColumnFilterModal={showColumnFilterModal}
                        handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                        selectedColumns={selectedColumns}
                        handleSaveColumns={handleColumnSelectionChange}
                    />
                )
            }
            {
                showValueFilterModal && (
                    <UserValueFilterModal
                        showValueFilterModal={showValueFilterModal}
                        handleCloseValueFilterModal={handleCloseValueFilterModal}
                    />
                )
            }
        </div >
    );
};

export default UserManagement;